const { createApp, onMounted, ref, computed } = Vue;
console.log(myCustomQAConfig, 'myCustomQAConfig')
createApp({
  compilerOptions: {
    delimiters: ["[[", "]]"],
  },
  setup() {
    const custom_config_key = "sweeper"
    const custom_config = ref({})
    const showResult = ref(false);
    // 问题列表配置
    const questionList = ref([
      {
        title: "ご自宅の広さはどちらに近いですか？",
        type: "single", // single: 单选, multiple: 多选
        optionList: [
          {
            id: "0-0",
            weightScore: 2,
            prodAblityScore: {
              s1plusw: 0,
              "k10+": 2,
              "k10+pro": 2,
              "k11+": 2,
              "k10+procombo": 2,
              "k20+pro": 0,
              s10: 1,
              s20: 1,
            },
            title: "50㎡未満",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_6422ec17-0e50-450e-a967-822aaa3868e1.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_1290e042-2ad3-4ec0-a5eb-6f46b51a37ab.webp?v=1758184738",
          },
          {
            id: "0-1",
            weightScore: 2,
            prodAblityScore: {
              s1plusw: 2,
              "k10+": 2,
              "k10+pro": 2,
              "k11+": 2,
              "k10+procombo": 2,
              "k20+pro": 2,
              s10: 2,
              s20: 2,
            },
            title: "50㎡以上",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_1.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_1.webp?v=1758184738",
          },
        ],
      },
      {
        title: "ご家庭の構成について、あてはまるものを選んでください",
        type: "multiple",
        optionList: [
          {
            id: "1-0",
            weightScore: 1,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 1,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "ペットと暮らしている",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_2.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_2.webp?v=1758184738",
          },
          {
            id: "1-1",
            weightScore: 1,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 2,
              "k10+pro": 2,
              "k11+": 2,
              "k10+procombo": 2,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "赤ちゃんがいる",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_3.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_3.webp?v=1758184738",
          },
          {
            id: "1-2",
            weightScore: 1,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 1,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "ひとり暮らし／ふたり暮らし",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_4.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_4.webp?v=1758184738",
          },
        ],
      },
      {
        title: "ご自宅の床について、あてはまるものを選んでください",
        type: "multiple",
        optionList: [
          {
            id: "2-0",
            weightScore: 1,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 1,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "フローリングなどの滑らかな床が中心",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_5.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_5.webp?v=1758184738",
          },
          {
            id: "2-1",
            weightScore: 1,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 2,
              "k20+pro": 1,
              s10: 2,
              s20: 2,
            },
            title: "カーペットやラグを敷いている",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_6.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_6.webp?v=1758184738",
          },
          {
            id: "2-2",
            weightScore: 1,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 1,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "部屋の間に段差や敷居がある",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_7.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_7.webp?v=1758184738",
          },
          {
            id: "2-3",
            weightScore: 1,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 1,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "畳の部屋がある",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_8.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_8.webp?v=1758184738",
          },
        ],
      },
      {
        title: "次のうち、ご自宅の環境により近いのはどちらですか？",
        type: "single",
        optionList: [
          {
            id: "3-0",
            weightScore: 3,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 1,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "家具や物が少なく、すっきりとした室内",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_9.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_9.webp?v=1758184738",
          },
          {
            id: "3-1",
            weightScore: 3,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 2,
              "k10+pro": 3,
              "k11+": 3,
              "k10+procombo": 3,
              "k20+pro": 2,
              s10: 1,
              s20: 1,
            },
            title: "家具やコードが多く、ロボット掃除機がひっかかりやすい",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_10.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_10.webp?v=1758184738",
          },
        ],
      },
      {
        title: "ご家庭の掃除で、特に気になるのはどちらですか？",
        type: "single",
        optionList: [
          {
            id: "4-0",
            weightScore: 3,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 2,
              "k10+pro": 3,
              "k11+": 4,
              "k10+procombo": 3,
              "k20+pro": 2,
              s10: 1,
              s20: 1,
            },
            title: "ホコリや軽い汚れなど、日常的な汚れが気になる",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_11.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3171_2x_11.webp?v=1758184738",
          },
          {
            id: "4-1",
            weightScore: 3,
            prodAblityScore: {
              s1plusw: 3,
              "k10+": 0,
              "k10+pro": 1,
              "k11+": 2,
              "k10+procombo": 0,
              "k20+pro": 0,
              s10: 3,
              s20: 4,
            },
            title: "油汚れやシミなど、落としにくい汚れに悩んでいる",
            imgPcurl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_12.webp?v=1758183449",
            imgMburl:
              "https://cdn.shopify.com/s/files/1/0522/2458/9999/files/3130_2x_12.webp?v=1758183449",
          },
        ],
      },
      {
        title: "ご購入時に重視するのはどちらですか？",
        type: "single",
        optionList: [
          {
            id: "5-0",
            weightScore: 10000,
            prodAblityScore: {
              s1plusw: 1,
              "k10+": 1,
              "k10+pro": 1,
              "k11+": 1,
              "k10+procombo": 0,
              "k20+pro": 0,
              s10: 0,
              s20: 0,
            },
            title: "できるだけコストを抑えたい（60,000円以下）",
            imgPcurl: "",
            imgMburl: "",
          },
          {
            id: "5-1",
            weightScore: 10000,
            prodAblityScore: {
              s1plusw: 0,
              "k10+": 0,
              "k10+pro": 0,
              "k11+": 0,
              "k10+procombo": 1,
              "k20+pro": 1,
              s10: 1,
              s20: 1,
            },
            title: "多少高くても、性能にこだわりたい（60,000円以上）",
            imgPcurl: "",
            imgMburl: "",
          },
        ],
      },
    ]);

    // 用户答案存储 - 二维数组，每个问题可以有多个答案
    const answers = ref([]);

    const answerIndexToLabel = ref([
      // 问题 1
      {
        0: "小户型",
        1: "大户型/高层住宅",
      },
      // 问题 2
      {
        0: "宠物家庭",
        1: "宝宝家庭",
        2: "单身/伴侣家庭",
      },
      // 问题 3
      {
        0: "硬地面",
        1: "地毯",
        2: "门槛",
        3: "榻榻米",
      },
      // 问题 4
      {
        0: "障碍物少（空间简单）",
        1: "障碍物多（空间复杂）",
      },
      // 问题 5
      {
        0: "一般污渍（标准拖地）",
        1: "顽固污渍（强力去污）",
      },
      {
        0: "6w日元以下",
        1: "6w日元以上",
      },
    ]);
    const prodToLable = {
      "k10+": [
        "小户型",
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宠物家庭",
        "硬地面",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "6w日元以下",
      ],
      "k10+pro": [
        "小户型",
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宠物家庭",
        "硬地面",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "6w日元以下",
      ],
      "k11+": [
        "小户型",
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宝宝家庭",
        "宠物家庭",
        "硬地面",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "6w日元以下",
      ],
      "k10+procombo": [
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宝宝家庭",
        "宠物家庭",
        "硬地面",
        "地毯",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "6w日元以上",
      ],
      "k20+pro": [
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宠物家庭",
        "硬地面",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "6w日元以上",
      ],
      s1plusw: [
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宠物家庭",
        "硬地面",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "6w日元以下",
      ],
      s10: [
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宝宝家庭",
        "宠物家庭",
        "硬地面",
        "地毯",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "自动清洗/烘干拖布",
        "6w日元以上",
      ],
      s20: [
        "大户型/高层住宅",
        "单身/伴侣家庭",
        "宝宝家庭",
        "宠物家庭",
        "硬地面",
        "地毯",
        "门槛",
        "避障",
        "拖地",
        "自动集尘",
        "自动清洗/烘干拖布",
        "6w日元以上",
      ],
    };
    const prodRecommondSocre = ref({
      "k10+": 0,
      "k10+pro": 0,
      "k11+": 0,
      "k10+procombo": 0,
      "k20+pro": 0,
      s1plusw: 0,
      s10: 0,
      s20: 0,
    });

    const higherSixWProd = ["k10+procombo", "k20+pro", "s10", "s20"];
    const lowerSixWProd = ["s1plusw", "k10+", "k10+pro", "k11+"];

    // 产品推荐结果展示的内容
    const prodRecommondSaveList = ref({
      "k10+": {
        title: "ロボット掃除機 K10＋",
        price: "¥59,800",
        handle: "/products/switchbot-robot-vacuum-cleaner-k10",
        detailHandle: "/pages/robot-vacuum-k10-smallest",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/K10__01_V3_2x_2f0f944c-797c-41c6-a850-97751c037217_700x700.png?v=1738919299",
        desc: "世界最小クラスのコンパクトボディで、狭い場所もスイスイ。静かで手間いらず、ペットのいるご家庭やワンルームにもぴったりのロボット掃除機です。",
        saleDesc: [
          "・直径約24.8cm、家具の下もスイスイ",
          "・SilenTech™最小約45dBの静音を実現",
          "・自動ゴミ収集、最大70日間お手入れ不要",
          "・LiDARナビで効率的な清掃ルート",
          "・バッテリー切れ時は自動充電・続き掃除",
          "・拭き掃除対応、使い捨てクロス付き",
          "・アプリ＆音声アシスタント連携対応",
        ],
      },
      "k10+pro": {
        title: "ロボット掃除機 K10+ Pro",
        price: "¥69,800",
        handle: "/products/switchbot-robot-vacuum-cleaner-k10-pro",
        detailHandle: "/pages/robot-vacuum-k10-pro-smallest",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/K5Z27J_D_2x_391c475d-162e-400c-bdac-9b0e57ec9a99_700x700.png?v=1742525683",
        desc: 'K10+ をさらに進化させた Pro モデル。障害物回避性能が大きく向上し、狭い空間も静かにすみずみまで清掃。ペットの毛も絡みにくい設計で、毎日の暮らしをより快適にサポートします。',
        saleDesc: [
          "・狭い場所にも強いコンパクト設計",
          "・PSDセンサー搭載で、障害物回避がさらに賢く",
          "・壁ぎわ検知でブラシが高速回転、汚れをしっかりかきだす",
          "・高精度レーザーナビで間取りを精密に把握",
          "・ペットの毛も絡みにくいブラシ設計",
          "・4L大容量の自動集じんステーションで手間を最小限に",
          "・SilenTech™で最小約45dBの静音性を実現",
        ],
      },
      "k11+": {
        title: "ロボット掃除機 K11+",
        price: "¥59,800",
        handle: "/products/switchbot-robot-vacuum-cleaner-k11",
        detailHandle: "/products/switchbot-robot-vacuum-cleaner-k11",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/00_1_700x700.webp?v=1751447191",
        desc: "小型ボディに「強力吸引＋超小型自動集塵ステーション」を両立。パワフルさと美しさを備えた小型ロボット掃除機の最上位モデル。",
        saleDesc: [
          "・お部屋に馴染む上質な木目調のデザイン",
          "・最大6000Paの強力吸引でペットの毛や頑固なゴミも一気に吸引",
          "・A4サイズ未満の超小型集塵ステーションで置き場所に困らない",
          "・4L抗菌ダストバッグ採用で最長約90日間ゴミ捨て不要",
          "・本体は直径24.8cm・高さ9.2cmの小型設計で家具の下もスイスイ掃除",
          "・ツインサイドブラシで壁際や隅のゴミも取り残さない",
          "・高精度レーザーナビでしっかり間取りを把握、お部屋の隅々まで清掃",
        ],
      },
      "k10+procombo": {
        title: "ロボット掃除機 K10+ Pro Combo",
        price: "¥99,800	",
        handle: "/products/robot-vacuum-cleaner-k10-pro-combo",
        detailHandle: "/products/robot-vacuum-cleaner-k10-pro-combo",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/333_2x_69ac3b2f-2f38-49ba-ae43-160c51b1b420_700x700.webp?v=1739442484",
        desc: 'ロボット、スティック掃除機、集塵ステーションをひとつに。スリムな「3-in-1」設計だから、狭いお部屋でも置き場所に困らない。床のホコリから棚上の掃除まで、手間なくサッとこなせる、毎日使いにぴったりの一台。',
        saleDesc: [
          "・ロボット＋スティックであらゆる場所のお掃除に対応",
          "・FusionBase縦置き収納で、限られた住まいでも省スペースに",
          "・デュアル自動集塵で両機種とも最大70日間お手入れ不要",
          "・スティック掃除機は4種ノズル付属。棚上やすき間もこれ1本で",
          "・わずか直径24.8cm。狭所や家具下もスイスイ走行",
          "・最小約45dB、夜も気にならないSilenTech™静音設計",
          "・アプリ＆音声アシスタント対応で、操作もスマートに",
        ],
      },
      "k20+pro": {
        title: "ロボット掃除機 K20+ Pro",
        price: "¥99,800",
        handle: "",
        detailHandle: "",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/K20_Pro_JP__1000x1000_1_2x_ab0bf455-f0ab-44de-ae37-c135c93b6c47_700x700.webp?v=1747195371",
        desc: "掃除だけじゃない。家電を動かし、荷物を運び、家族を見守る──暮らしに寄り添う“相棒”型マルチタスクロボット。",
        saleDesc: [
          "・お掃除のプロ：狭い場所でもすみずみまで清掃、スティックと組み合わせてお部屋中をカバー",
          "・荷物の運搬も：飲み物やデリバリーも運搬可能",
          "・空気・温湿度に連動：室内環境に合わせて空気清浄機やサーキュレーターを乗せ、快適をお届け",
          "・見守り＆防犯対応：カメラを乗せてお部屋を見回り、通話や見守りにも",
          "・高精度ナビゲーション：3つのLiDARで障害物回避し、段差も自動で認識",
          "・多様な操作方法：スマホ・音声・ボタン・自動操作に対応",
        ],
      },
      s1plusw: {
        title: "ロボット掃除機 S1 Plus W",
        price: "¥69,800",
        handle: "/products/switchbot-robot-vacuum-cleaner",
        detailHandle: "/pages/robot-vacuum",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/output_1_e66dfed1-7fe9-415c-84f5-40f6bbd9ec22_700x700.webp?v=1705650488",
        desc: "自動集じんベース（4L）を備え、吸引も水拭きもこれ1台。長時間稼働と高精度マッピングで、掃除の手間を大きく減らすスマートモデルです。",
        saleDesc: [
          "・自動ゴミ収集ベース付属で最大70日間ゴミ捨て不要",
          "・吸引＋水拭きの2-in-1で日常の掃除を1ステップにまとめて、時短＆ラクに",
          "・ブラシレスモーターで最大約2700Paの吸引力を実現",
          "・LDSレーザー＋SLAMによる高精度マッピングで効率的に走行",
          "・カーペットを検知するとモップを自動で持ち上げ、濡れ移りを防止",
          "・アプリで立入禁止エリアや水拭き禁止エリアを細かく設定可能",
          "・音声アシスタント対応でハンズフリー操作が可能",
        ],
      },
      s10: {
        title: "お掃除ロボット S10",
        price: "¥119,820",
        handle: "/products/switchbot-robot-vacuum-cleaner-s10",
        detailHandle: "/pages/switchbot-robot-vacuum-cleaner-s10",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/S10_700x700.webp?v=1738918622",
        desc: "給水から排水、モップの洗浄・乾燥まですべて自動。拭き掃除を「ほぼ完全自動化」する、手間いらずのハイブリッド掃除機。",
        saleDesc: [
          "・水道直結ステーションで給水・排水を自動化",
          "・RinseSync（モップのリアルタイム洗浄）により常に清潔なモップで拭き取り",
          "・RevoRoll（ローラーモップ）が反転洗浄で汚れを除去、手で擦ったような洗浄力",
          "・最大6500Paの強力吸引でペットの毛やカーペットの奥までしっかり吸い取る",
          "・カーペットを検知するとモップを自動で持ち上げ、濡れ移りを防止",
          "・モップの熱風乾燥機能で、使用後も衛生的",
          "・給排水＆集塵の自動化により、日々のメンテナンスも最小限",
        ],
      },
      s20: {
        title: "お掃除ロボット S20",
        price: "¥91,800",
        handle: "/products/switchbot-robot-vacuum-cleaner-s20",
        detailHandle: "/products/switchbot-robot-vacuum-cleaner-s20",
        imgurl:
          "https://www.switchbot.jp/cdn/shop/files/1000x1000_S20_2x_c1c16ac0-9354-4a23-ae19-9283713d0463_700x700.webp?v=1746783669",
        desc: "給排水・モップ洗浄・乾燥・集塵を一台で自動化する「MultiCleanステーション」を搭載し、配管不要でほぼ手放し運用ができるハイエンドのお掃除ロボット。",
        saleDesc: [
          "・給水・汚水回収・モップ洗浄・熱風乾燥・集塵までをすべて自動化",
          "・モップを走行中に常時洗浄する回転ローラー構造で、汚れを広げずに拭き上げる",
          "・最大約10,000Pa相当の強力吸引で頑固な汚れも効率的に除去",
          "・毛が絡みにくいブラシ構造でペット毛や髪の毛のお手入れもラク",
          "・カーペットを検知するとモップを自動で持ち上げ、濡れ移りを防止",
          "・高精度ナビ（dToF/LiDAR）と前方カメラで障害物回避と効率的な走行を両立",
          "・高密閉設計＋大容量集塵で、最大約90日間ゴミ捨て不要",
        ],
      },
    });

    // 初始化答案数组
    onMounted(() => {
      // console.log(myCustomQAConfig, 'myCustomQAConfig');
      // custom_config.value = myCustomQAConfig[custom_config_key];
      let config = myCustomQAConfig.find(item => item.key === custom_config_key);
      if (!config || !config.config || !config.config.length) {
        console.error('custom_config_key not found in myCustomQAConfig');
      }
      custom_config.value = config?.config || [];
      questionList.value.forEach(() => {
        answers.value.push([]);
      });
      if (custom_config.value&&custom_config.value.length){
        custom_config.value.map(item => {
          // prodName
          if (!item.prodName) return;
          if (prodRecommondSaveList.value[item.prodName]&&prodRecommondSaveList.value[item.prodName].title) {
            prodRecommondSaveList.value[item.prodName].config = item || {};
          }
        });
      }
      console.log(prodRecommondSaveList.value, 'prodRecommondSaveList');
    });

    // 点击开始按钮
    const showStart = ref(true);
    const myCustomClickStart = () => {
      showStart.value = false;
    }

    // 通过点击 页面调整到对应的问卷问题
    const pcHeight = 410;
    const mbHeight = 540;

    let yPosition = ref(0);
    const handleQANextAndPre = (type, index) => {
      console.log(type, index);
      console.log(answers.value, 'answers');
      let height = window.screen.width > 767 ? pcHeight : mbHeight;
      if (type === "prev") {
        if (index === 0) return;
        yPosition.value = (index - 1) * height;
      } else if (type === "next") {
        // 如果当前问题没有回答，不能继续往下
        if (answers.value[index].length === 0) {
          // alert("先にこの質問に回答してください。");
          myCustomQATipShowFn("先にこの質問に回答してください。","error")
          return
        }
        if (index === questionList.value.length - 1) return;
        yPosition.value = (index + 1) * height;
      }
    };

    // 检查选项是否被选中
    const isOptionSelected = (questionIndex, optionIndex) => {
      return answers.value[questionIndex]?.includes(optionIndex) || false;
    };

    // 选择选项
    const selectOption = (questionIndex, optionIndex, option) => {
      const question = questionList.value[questionIndex];

      if (question.type === "single") {
        // 单选：替换当前答案
        answers.value[questionIndex] = [optionIndex];
      } else {
        // 多选：切换选项
        const currentAnswers = answers.value[questionIndex];
        const existingIndex = currentAnswers.indexOf(optionIndex);

        if (existingIndex > -1) {
          // 已选中，取消选择
          currentAnswers.splice(existingIndex, 1);
        } else {
          // 未选中，添加选择
          currentAnswers.push(optionIndex);
        }

      }
    };

    // 检查是否所有问题都已回答
    const isAllQuestionsAnswered = computed(() => {
      return answers.value.every((answer) => answer.length > 0);
    });

    // 获取答案文本
    const getAnswerText = (questionIndex) => {
      const question = questionList.value[questionIndex];
      const questionAnswers = answers.value[questionIndex];

      return questionAnswers
        .map((optionIndex) => question.optionList[optionIndex].title)
        .join(", ");
    };

    // 提交问卷
    let firstProdObj = ref({})
    let secondProdObj = ref({})

    const submitQuestionnaire = () => {
      if (!isAllQuestionsAnswered.value) {
        // alert("先にこの質問に回答してください。");
        myCustomQATipShowFn("先にこの質問に回答してください。","error")
        return;
      }

      // 这里可以发送数据到服务器
      console.log("问卷结果:", answers.value);

      // 显示结果
      showResult.value = true;

      // 滚动到结果区域
      setTimeout(() => {
        const resultEl = document.querySelector(".result-wrap");
        if (resultEl) {
          resultEl.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);

      
      // 注意，后续如果使用每个tag的权重，可以替换这里的函数如下
      for (let key in prodRecommondSocre.value) {
          prodRecommondSocre.value[key] = 0;
      }
      console.log(prodRecommondSocre.value, "prodRecommondSocre");

      // 从 answers 和  questionList 获取出来，对应的选项的内容。成为一个数组。然后遍历数组把数组中 prodAblityScore 的每个得分计算并赋值给 prodRecommondSocre 这样就得到最终的得分
      answers.value.map((answer, answerIndex)=>{
        let aOpts =  questionList.value[answerIndex]?.optionList || []
        console.log(answer, 'answer')
        console.log(aOpts,'aOpts')
        if(!aOpts || !aOpts?.length || !answer || !answer.length) return
        answer.map((j)=>{
          let aOptsItem = aOpts[j]
          console.log(aOptsItem, 'aOptsItem')
          for (let key in prodRecommondSocre.value) {
              prodRecommondSocre.value[key] += aOptsItem.prodAblityScore[key]*aOptsItem.weightScore;
          }
        })
      })
      console.log(prodRecommondSocre.value, "prodRecommondSocre");

      // 对每个产品的分数进行排序
      const entriesScore = Object.entries(prodRecommondSocre.value);
      // 按分数从大到小排序
      entriesScore.sort((a, b) => b[1] - a[1]);

      // 取前三名
      const top2 = entriesScore.slice(0, 2);
      const top2Names = top2.map(([name]) => name);
      console.log(top2, top2Names, 'sssss')
      // 从前 2 名的 名字数组 获取出 对应的产品内容
      let firstName = top2Names[0]
      let secondName = top2Names[1]
      firstProdObj.value = prodRecommondSaveList.value[firstName]
      secondProdObj.value = prodRecommondSaveList.value[secondName]

      console.log(firstProdObj.value)
      console.log(secondProdObj.value)

      // alert("質問は正常に送信されました！");
    };

    // 重置问卷
    const resetQuestionnaire = () => {
      showResult.value = false;
      // 重新初始化答案数组
      answers.value = [];
      questionList.value.forEach(() => {
        answers.value.push([]);
      });
      firstProdObj.value = {};
      secondProdObj.value = {};
      prodRecommondSocre.value = {
        "k10+": 0,
        "k10+pro": 0,
        "k11+": 0,
        "k10+procombo": 0,
        "k20+pro": 0,
        s1plusw: 0,
        s10: 0,
        s20: 0,
      }
      // 滚动到顶部
      yPosition.value = 0;
    };

    // 复制优惠券代码
    const myCustomCopyCouponCode = (couponCode) => {
      if (!couponCode) return
      navigator.clipboard.writeText(couponCode).then(() => {
        // alert("クーポンコードはコピーされました！");
        myCustomQATipShowFn("クーポンコードはコピーされました！","success")
      }).catch((err) => {
        console.error("复制错误", err);
        myCustomQATipShowFn("エラーが発生しました。","error")
      });
    }

    // 展示提示
    let myCustomQATip = ref({
      show: false,
      str: '',
      type: ''
    })
    const myCustomQATipShowFn = (str,type)=>{
      myCustomQATip.value.str = str
      myCustomQATip.value.type = type
      myCustomQATip.value.show = true
      setTimeout(()=>{
        myCustomQATip.value.show = false
        myCustomQATip.value.type = ""
        myCustomQATip.value.str = ""
      }, 3000)
    }

    return {
      yPosition,
      handleQANextAndPre,
      questionList,
      answers,
      showResult,
      isOptionSelected,
      selectOption,
      isAllQuestionsAnswered,
      getAnswerText,
      submitQuestionnaire,
      prodRecommondSocre,
      firstProdObj,
      secondProdObj,
      resetQuestionnaire,
      myCustomCopyCouponCode,
      myCustomClickStart,
      showStart,
      myCustomQATip,
    };
  },
}).mount("#myCustomSweeperQAWrapId");

setTimeout(() => {
  let appDom = document.getElementById("myCustomSweeperQAWrapId");
  appDom.style.visibility = "visible";
}, 500);
